import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { StarRating } from '@nerdwallet/currency';
import Popover from '@nerdwallet/react-popover';

const EditorRating = ({
  rating,
  slug,
  copyStyle,
  className,
  linkToDetails,
  multiLine,
}) => {
  const title = rating ? `${rating} / 5.0` : 'Loading...';
  const popoverContent =
    '<p>NerdWallet’s ratings are determined by our editorial team. The scoring formula takes into account the type of card being reviewed (such as cash back, travel or balance transfer) and the card’s rates, fees, rewards and other features.</p>';
  const mainClassnames = classNames('editor-rating', className);
  const numLines = classNames({
    'one-line': !multiLine,
    'multi-line': multiLine,
  });
  const labelClassnames = classNames('editor-rating__rating-text', copyStyle);

  const popoverArgs = {
    popoverContent: (
      // eslint-disable-next-line react/no-danger -- directive added automatically by Shepherd migration
      <div dangerouslySetInnerHTML={{ __html: popoverContent }} />
    ),
    id: 'ser-popover',
    type: ['hover', 'click'],
  };

  const ratingText = linkToDetails ? (
    <a className={labelClassnames} href={`/card-details/card-name/${slug}`}>
      NerdWallet Rating
    </a>
  ) : (
    <div className={labelClassnames}>NerdWallet Rating</div>
  );

  return (
    <div className={mainClassnames} title={title} alt={title}>
      <div className={numLines}>
        <Popover {...popoverArgs}>
          <StarRating rating={rating} nerdwallet />
          {ratingText}
        </Popover>
      </div>
    </div>
  );
};

EditorRating.displayName = 'EditorRating';

EditorRating.propTypes = {
  rating: PropTypes.number,
  slug: PropTypes.string,
  className: PropTypes.string,
  copyStyle: PropTypes.string,
  linkToDetails: PropTypes.bool,
  multiLine: PropTypes.bool,
};

EditorRating.defaultProps = {
  linkToDetails: true,
  multiLine: false,
};

export default EditorRating;
